import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { fileThumbnail } from './FileThumbnail.definition';
import { chameleonSvg } from '../Svg';
import { chameleonIconBadgeV2 } from '../IconBadge/IconBadge.definition';
import { chameleonCircularProgress } from '../CircularProgress/CircularProgress.definition';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), fileThumbnail({ prefix }), chameleonSvg({ prefix }), chameleonIconBadgeV2({ prefix }), chameleonCircularProgress({ prefix }));
}
